export const occupation = [
  '직접입력',
  '강구조물 가공원 및 건립원',
  '건설 및 광업 단순 종사원',
  '건설 및 채굴기계 운전원',
  '건설 배관공',
  '건설·광업기계 설치공',
  '건축 도장공',
  '건축 목공',
  '건축 석공',
  '경량 철골공',
  '공업 배관공',
  '공업기계 설치공',
  '광원·채석원 및 석재 절단원',
  '기타 건설 관련 기능 종사원',
  '기타 건축 마감 관련 기능 종사원',
  '기타 배관공',
  '기타 운송장비 정비공',
  '기타 전기·전자기기 설치공',
  '기타 정보 통신기기 설치공',
  '기타 채굴 및 토목 관련 종사원',
  '내선 전기공',
  '냉동·냉장·공조기 설치공',
  '농업용·기타 기계장비 설치공',
  '단열공',
  '도배공 및 유리 부착원',
  '도장공',
  '로봇 설치공',
  '물품 이동 장비 설치공',
  '미장공',
  '바닥재 시공원',
  '발전 및 배전 장치 설치공',
  '방송 관련 장비 설치공',
  '방송·통신·인터넷 케이블 설치공',
  '방수공',
  '보일러 설치공',
  '보통인부',
  '산업 전기공',
  '새시 조립 및 설치원',
  '승강기 설치공',
  '신호수',
  '외선 전기공',
  '용접공',
  '운송장비 조립공',
  '일반기계 조립공',
  '전기 및 전자설비 설치공',
  '조적공 및 석재 부설원',
  '철근공',
  '철로 설치 및 보수원',
  '콘크리트 타설공',
  '통신 관련 장비 설치공'
]
